import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './cta-components.component.scss';
var CtaComponents = /** @class */ (function (_super) {
    tslib_1.__extends(CtaComponents, _super);
    function CtaComponents(element) {
        return _super.call(this, element) || this;
    }
    CtaComponents.prototype.init = function () {
    };
    CtaComponents.prototype.bindEvents = function () {
    };
    return CtaComponents;
}(Base));
export { CtaComponents };



//////////////////
// WEBPACK FOOTER
// ./components/cta-components/cta-components.component.ts
// module id = 244
// module chunks = 0